export default __webpack_public_path__ + "static/media/learn-from-prototype-arrow-desktop.96a0e54e.svg";